import { useDispatch, useSelector } from "react-redux"
import { appdataSelector } from "reducers/appdata/appdata";
import { vendordataSelector, vendordata_updateActiveVendor } from "reducers/vendordata/vendordata"
import { formatData } from "./VendordataHelper";
import { Card } from "@mui/material";

function VendordataEditablePurchasingData(props) {
  const vendordata = useSelector(vendordataSelector);
  const appdata = useSelector(appdataSelector);
  const dispatch = useDispatch();
  const inputWidth = "100%";

  const styles = {
    myInput: {
      width: inputWidth
    },
    mySelect: {
      height: 30,
      width: inputWidth
    }
  };

  let part = { ...vendordata.vendorParts.PURCHASING };
  let data = formatData("PURCHASING", part, appdata, vendordata);


  const handleChange = (event, key) => {
    console.log("handle change", event.target.value, key);
    dispatch(
      vendordata_updateActiveVendor({
        part: "PURCHASING",
        key: key,
        value: event.target.value
      })
    );
  };

  let disabled = false;
  if (vendordata.activeVendor.master) {
      if (vendordata.activeVendor.master.KTOKK.substring(0, 2) == "EM") {
        disabled = true;
    }
  }

  return (
    <Card className="p-4 mt-2" key="Card">
      <div className="row border-bottom mb-2 pb-2">
        <div className="col-3 d-none d-md-block">Label</div>
        <div className="col-6 col-md-4">New value</div>
        {appdata.activeRequestType != "NV" && (
          <div className="col-6 col-md-5">Original value</div>
        )}
      </div>

      {Object.keys(data).map(key => {
        let typeIsDropdown = data[key].hasOwnProperty("key") ? true : false;
        let alternativeText = data[key].hasOwnProperty("alternativeText")
          ? true
          : false;

        let highlightInfo = false;
        if (appdata.activeRequestType != "NV") {
          if (data[key].active != data[key].sap) {
            highlightInfo = true;
          }
        }

        return (
          <div className={(highlightInfo) ? "border border-info row mt-1 mb-1" : "row mt-1 mb-1"} key={"rowpart" + key}>
            <div className="col-3 d-none d-md-flex align-items-center" key={"label" + key}>
              <b>
                {data[key].label} {data[key].required ? "*" : ""}
              </b>
            </div>
            {typeIsDropdown && (
              <div className="col-6 col-md-4" key={"dropdown" + key}>
                {" "}
                <select
                  disabled={disabled} 
                  key={key + "selection"}
                  /* id={selectkey} */
                  /* name={seltype + "selection"} */
                  className="d-print-none"
                  style={styles.mySelect}
                  onChange={event => {
                    //props.handleSelect(event, part);
                    handleChange(event, key);
                  }}
                  value={data[key].value}
                >
                  <option hidden></option>
                  {data[key].list &&
                    data[key].list.map((item, keyIntern) => {
                      return (
                        <option
                          key={key + "_option" + keyIntern}
                          value={item[data[key].listKeys[0]]}
                        >
                          {item[data[key].listKeys[0]] +
                            " - " +
                            item[data[key].listKeys[1]]}
                        </option>
                      );
                    })}
                </select>
              </div>
            )}
            {!typeIsDropdown && !alternativeText && (
              <div className="col-6 col-md-4">
                <input
                  disabled={disabled}
                  style={styles.myInput}
                  onChange={event => {
                    handleChange(
                      event,
                      key
                    );
                  }}
                  /* hidden={hidden} */
                  key={"input" + key}
                  /* id={key} */
                  type="text"
                  value={data[key].active ? data[key].active : ""}
                /* maxLength={maxChars ? maxChars : null} */
                ></input>
              </div>
            )}
            {alternativeText && (
              <div className="col-6 col-md-4" key={"alternativeText" + key}>
                {data[key].alternativeText}
              </div>
            )}
            <div className="col-6 col-md-5 d-flex align-items-center" style={{ textDecoration: highlightInfo ? "line-through" : "" }}>{data[key].sap}</div>
          </div>
        );
      })}
    </Card>
  );
}

export default VendordataEditablePurchasingData